import React from 'react';

import { SearchableSelectType } from 'components/inputs/searchableSelect';
import SingleSelectFilter from 'components/tables/filters/SingleSelectFilter';
import styled from 'styled-components';

import aampeTheme from '../../constants/aampeTheme';

import {
    AuditTrailFilterValue,
    AuditTrailTimeframeOptions,
} from 'models/activty-log.model';

export const TIMEFRAME_OPTIONS: SearchableSelectType[] = [
    { label: 'Lifetime', value: AuditTrailTimeframeOptions.LIFETIME },
    { label: 'This month', value: AuditTrailTimeframeOptions.MONTH },
    { label: 'This week', value: AuditTrailTimeframeOptions.WEEK },
];
type AuditTrailFiltersProps = {
    personFilterOptions: { label: string; value: number | string }[];
    value: AuditTrailFilterValue;
    onChange: (field: keyof AuditTrailFilterValue, value: string) => void;
    /** Render menus here (e.g. document.body) when an ancestor would clip them. */
    menuPortalTarget?: HTMLElement | null;
};
const AuditTrailFilters: React.FC<AuditTrailFiltersProps> = ({
    personFilterOptions,
    value,
    onChange,
    menuPortalTarget,
}) => {
    const personOptions: SearchableSelectType[] = [
        { label: 'All', value: 'all' },
        ...personFilterOptions,
    ];
    return (
        <FiltersRow>
            <SingleSelectFilter
                name="timeframe"
                menuPortalTarget={menuPortalTarget}
                label=""
                placeholder="Timeframe"
                options={TIMEFRAME_OPTIONS}
                value={TIMEFRAME_OPTIONS.find(
                    (o) => o.value === value.timeframe,
                )}
                onChange={(_, selected) =>
                    onChange(
                        'timeframe',
                        String((selected as SearchableSelectType).value),
                    )
                }
            />
            <SingleSelectFilter
                name="person"
                menuPortalTarget={menuPortalTarget}
                menuAlign="right"
                label="By Person"
                placeholder="By Person"
                options={personOptions}
                value={personOptions.find(
                    (o) => String(o.value) === value.person,
                )}
                onChange={(_, selected) =>
                    onChange(
                        'person',
                        String((selected as SearchableSelectType).value),
                    )
                }
            />
        </FiltersRow>
    );
};
const FiltersRow = styled.div({
    display: 'flex',
    alignItems: 'center',
    gap: aampeTheme.spacing4(2),
});
export default AuditTrailFilters;
